/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as NotVerifiedRouteImport } from './routes/not-verified'
import { Route as VerifiedRouteImport } from './routes/verified'
import { Route as AuthMainRouteImport } from './routes/_auth._main'
import { Route as AuthSimpleRouteImport } from './routes/_auth._simple'
import { Route as AuthBoardRouteImport } from './routes/_auth.board'
import { Route as GuestIndexRouteImport } from './routes/_guest.index'
import { Route as GuestForgotRouteImport } from './routes/_guest.forgot'
import { Route as GuestLoginRouteImport } from './routes/_guest.login'
import { Route as GuestResetRouteImport } from './routes/_guest.reset'
import { Route as ApplyPreviewSiteKeyRouteImport } from './routes/apply-preview.$siteKey'
import { Route as ApplyPublicIdRouteImport } from './routes/apply.$publicId'
import { Route as AuthMainClientsRouteImport } from './routes/_auth._main.clients'
import { Route as AuthMainColleaguesRouteImport } from './routes/_auth._main.colleagues'
import { Route as AuthMainCompanyRouteImport } from './routes/_auth._main.company'
import { Route as AuthMainDashboardRouteImport } from './routes/_auth._main.dashboard'
import { Route as AuthMainIntegrationsRouteImport } from './routes/_auth._main.integrations'
import { Route as AuthMainInvitationsRouteImport } from './routes/_auth._main.invitations'
import { Route as AuthMainProfileRouteImport } from './routes/_auth._main.profile'
import { Route as AuthMainSettingsRouteImport } from './routes/_auth._main.settings'
import { Route as AuthMainCampaignsIndexRouteImport } from './routes/_auth._main.campaigns.index'
import { Route as AuthMainCampaignsCampaignIdRouteImport } from './routes/_auth._main.campaigns.$campaignId'
import { Route as AuthMainCandidatesIndexRouteImport } from './routes/_auth._main.candidates.index'
import { Route as AuthMainCompaniesIndexRouteImport } from './routes/_auth._main.companies.index'
import { Route as AuthMainUsersIndexRouteImport } from './routes/_auth._main.users.index'
import { Route as AuthMainUsersCreateRouteImport } from './routes/_auth._main.users.create'
import { Route as AuthMainWebhooksWebhookIdRouteImport } from './routes/_auth._main.webhooks.$webhookId'
import { Route as AuthMainWebsitesIndexRouteImport } from './routes/_auth._main.websites.index'
import { Route as AuthMainWebsitesSiteIdRouteImport } from './routes/_auth._main.websites.$siteId'
import { Route as AuthMainWhatsappBusinessAccountsIndexRouteImport } from './routes/_auth._main.whatsapp-business-accounts.index'
import { Route as AuthSimpleCampaignsCreateRouteImport } from './routes/_auth._simple.campaigns.create'
import { Route as AuthSimpleConnectWordpressRouteImport } from './routes/_auth._simple.connect.wordpress'
import { Route as AuthCampaignsCampaignIdFullBoardRouteImport } from './routes/_auth.campaigns.$campaignId.full-board'
import { Route as AuthMainCampaignsCampaignIdBoardRouteImport } from './routes/_auth._main.campaigns.$campaignId.board'
import { Route as AuthMainCampaignsCampaignIdSettingsRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings'
import { Route as AuthMainCompaniesCompanyIdIndexRouteImport } from './routes/_auth._main.companies.$companyId.index'
import { Route as AuthMainUsersUserIdIndexRouteImport } from './routes/_auth._main.users.$userId.index'
import { Route as AuthMainUsersUserIdEditRouteImport } from './routes/_auth._main.users.$userId.edit'
import { Route as AuthMainWebsitesSiteIdIndexRouteImport } from './routes/_auth._main.websites.$siteId.index'
import { Route as AuthMainWebsitesSiteIdSettingsRouteImport } from './routes/_auth._main.websites.$siteId.settings'
import { Route as AuthMainWhatsappBusinessAccountsAccountIdIndexRouteImport } from './routes/_auth._main.whatsapp-business-accounts.$accountId.index'
import { Route as AuthMainCampaignsCampaignIdSettingsIndexRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.index'
import { Route as AuthMainCampaignsCampaignIdSettingsCandidateSourcesRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.candidate-sources'
import { Route as AuthMainCampaignsCampaignIdSettingsClientsRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.clients'
import { Route as AuthMainCampaignsCampaignIdSettingsContentRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.content'
import { Route as AuthMainCampaignsCampaignIdSettingsCustomAttributesRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.custom-attributes'
import { Route as AuthMainCampaignsCampaignIdSettingsLeadFormRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.lead-form'
import { Route as AuthMainCampaignsCampaignIdSettingsMissedCandidatesRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.missed-candidates'
import { Route as AuthMainCampaignsCampaignIdSettingsNotificationsRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.notifications'
import { Route as AuthMainCampaignsCampaignIdSettingsTryOutRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.try-out'
import { Route as AuthMainCampaignsCampaignIdSettingsWhatsappRouteImport } from './routes/_auth._main.campaigns.$campaignId.settings.whatsapp'
import { Route as AuthMainWebsitesSiteIdSettingsIndexRouteImport } from './routes/_auth._main.websites.$siteId.settings.index'
import { Route as AuthMainWebsitesSiteIdSettingsApplyFormRouteImport } from './routes/_auth._main.websites.$siteId.settings.apply-form'
import { Route as AuthMainWebsitesSiteIdSettingsChatRouteImport } from './routes/_auth._main.websites.$siteId.settings.chat'
import { Route as AuthMainWebsitesSiteIdSettingsConnectionRouteImport } from './routes/_auth._main.websites.$siteId.settings.connection'
import { Route as AuthMainWebsitesSiteIdSettingsKnowledgeRouteImport } from './routes/_auth._main.websites.$siteId.settings.knowledge'
import { Route as AuthMainWebsitesSiteIdSettingsVacanciesRouteImport } from './routes/_auth._main.websites.$siteId.settings.vacancies'
import { Route as AuthMainWebsitesSiteIdSettingsWhatsappRouteImport } from './routes/_auth._main.websites.$siteId.settings.whatsapp'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const NotVerifiedRoute = NotVerifiedRouteImport.update({
  id: '/not-verified',
  path: '/not-verified',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifiedRoute = VerifiedRouteImport.update({
  id: '/verified',
  path: '/verified',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMainRoute = AuthMainRouteImport.update({
  id: '/_main',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSimpleRoute = AuthSimpleRouteImport.update({
  id: '/_simple',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBoardRoute = AuthBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AuthRoute,
} as any)
const GuestIndexRoute = GuestIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuestRoute,
} as any)
const GuestForgotRoute = GuestForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => GuestRoute,
} as any)
const GuestLoginRoute = GuestLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => GuestRoute,
} as any)
const GuestResetRoute = GuestResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => GuestRoute,
} as any)
const ApplyPreviewSiteKeyRoute = ApplyPreviewSiteKeyRouteImport.update({
  id: '/apply-preview/$siteKey',
  path: '/apply-preview/$siteKey',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyPublicIdRoute = ApplyPublicIdRouteImport.update({
  id: '/apply/$publicId',
  path: '/apply/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMainClientsRoute = AuthMainClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainColleaguesRoute = AuthMainColleaguesRouteImport.update({
  id: '/colleagues',
  path: '/colleagues',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainCompanyRoute = AuthMainCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainDashboardRoute = AuthMainDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainIntegrationsRoute = AuthMainIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainInvitationsRoute = AuthMainInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainProfileRoute = AuthMainProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainSettingsRoute = AuthMainSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainCampaignsIndexRoute = AuthMainCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainCampaignsCampaignIdRoute =
  AuthMainCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthMainRoute,
  } as any)
const AuthMainCandidatesIndexRoute = AuthMainCandidatesIndexRouteImport.update({
  id: '/candidates/',
  path: '/candidates/',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainCompaniesIndexRoute = AuthMainCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainUsersIndexRoute = AuthMainUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainUsersCreateRoute = AuthMainUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainWebhooksWebhookIdRoute =
  AuthMainWebhooksWebhookIdRouteImport.update({
    id: '/webhooks/$webhookId',
    path: '/webhooks/$webhookId',
    getParentRoute: () => AuthMainRoute,
  } as any)
const AuthMainWebsitesIndexRoute = AuthMainWebsitesIndexRouteImport.update({
  id: '/websites/',
  path: '/websites/',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainWebsitesSiteIdRoute = AuthMainWebsitesSiteIdRouteImport.update({
  id: '/websites/$siteId',
  path: '/websites/$siteId',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainWhatsappBusinessAccountsIndexRoute =
  AuthMainWhatsappBusinessAccountsIndexRouteImport.update({
    id: '/whatsapp-business-accounts/',
    path: '/whatsapp-business-accounts/',
    getParentRoute: () => AuthMainRoute,
  } as any)
const AuthSimpleCampaignsCreateRoute =
  AuthSimpleCampaignsCreateRouteImport.update({
    id: '/campaigns/create',
    path: '/campaigns/create',
    getParentRoute: () => AuthSimpleRoute,
  } as any)
const AuthSimpleConnectWordpressRoute =
  AuthSimpleConnectWordpressRouteImport.update({
    id: '/connect/wordpress',
    path: '/connect/wordpress',
    getParentRoute: () => AuthSimpleRoute,
  } as any)
const AuthCampaignsCampaignIdFullBoardRoute =
  AuthCampaignsCampaignIdFullBoardRouteImport.update({
    id: '/campaigns/$campaignId/full-board',
    path: '/campaigns/$campaignId/full-board',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMainCampaignsCampaignIdBoardRoute =
  AuthMainCampaignsCampaignIdBoardRouteImport.update({
    id: '/board',
    path: '/board',
    getParentRoute: () => AuthMainCampaignsCampaignIdRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsRoute =
  AuthMainCampaignsCampaignIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthMainCampaignsCampaignIdRoute,
  } as any)
const AuthMainCompaniesCompanyIdIndexRoute =
  AuthMainCompaniesCompanyIdIndexRouteImport.update({
    id: '/companies/$companyId/',
    path: '/companies/$companyId/',
    getParentRoute: () => AuthMainRoute,
  } as any)
const AuthMainUsersUserIdIndexRoute =
  AuthMainUsersUserIdIndexRouteImport.update({
    id: '/users/$userId/',
    path: '/users/$userId/',
    getParentRoute: () => AuthMainRoute,
  } as any)
const AuthMainUsersUserIdEditRoute = AuthMainUsersUserIdEditRouteImport.update({
  id: '/users/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => AuthMainRoute,
} as any)
const AuthMainWebsitesSiteIdIndexRoute =
  AuthMainWebsitesSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMainWebsitesSiteIdRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsRoute =
  AuthMainWebsitesSiteIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthMainWebsitesSiteIdRoute,
  } as any)
const AuthMainWhatsappBusinessAccountsAccountIdIndexRoute =
  AuthMainWhatsappBusinessAccountsAccountIdIndexRouteImport.update({
    id: '/whatsapp-business-accounts/$accountId/',
    path: '/whatsapp-business-accounts/$accountId/',
    getParentRoute: () => AuthMainRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsIndexRoute =
  AuthMainCampaignsCampaignIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute =
  AuthMainCampaignsCampaignIdSettingsCandidateSourcesRouteImport.update({
    id: '/candidate-sources',
    path: '/candidate-sources',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsClientsRoute =
  AuthMainCampaignsCampaignIdSettingsClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsContentRoute =
  AuthMainCampaignsCampaignIdSettingsContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute =
  AuthMainCampaignsCampaignIdSettingsCustomAttributesRouteImport.update({
    id: '/custom-attributes',
    path: '/custom-attributes',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsLeadFormRoute =
  AuthMainCampaignsCampaignIdSettingsLeadFormRouteImport.update({
    id: '/lead-form',
    path: '/lead-form',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute =
  AuthMainCampaignsCampaignIdSettingsMissedCandidatesRouteImport.update({
    id: '/missed-candidates',
    path: '/missed-candidates',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsNotificationsRoute =
  AuthMainCampaignsCampaignIdSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsTryOutRoute =
  AuthMainCampaignsCampaignIdSettingsTryOutRouteImport.update({
    id: '/try-out',
    path: '/try-out',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainCampaignsCampaignIdSettingsWhatsappRoute =
  AuthMainCampaignsCampaignIdSettingsWhatsappRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AuthMainCampaignsCampaignIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsIndexRoute =
  AuthMainWebsitesSiteIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsApplyFormRoute =
  AuthMainWebsitesSiteIdSettingsApplyFormRouteImport.update({
    id: '/apply-form',
    path: '/apply-form',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsChatRoute =
  AuthMainWebsitesSiteIdSettingsChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsConnectionRoute =
  AuthMainWebsitesSiteIdSettingsConnectionRouteImport.update({
    id: '/connection',
    path: '/connection',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsKnowledgeRoute =
  AuthMainWebsitesSiteIdSettingsKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsVacanciesRoute =
  AuthMainWebsitesSiteIdSettingsVacanciesRouteImport.update({
    id: '/vacancies',
    path: '/vacancies',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)
const AuthMainWebsitesSiteIdSettingsWhatsappRoute =
  AuthMainWebsitesSiteIdSettingsWhatsappRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AuthMainWebsitesSiteIdSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof GuestIndexRoute
  '/not-verified': typeof NotVerifiedRoute
  '/verified': typeof VerifiedRoute
  '/board': typeof AuthBoardRoute
  '/forgot': typeof GuestForgotRoute
  '/login': typeof GuestLoginRoute
  '/reset': typeof GuestResetRoute
  '/apply-preview/$siteKey': typeof ApplyPreviewSiteKeyRoute
  '/apply/$publicId': typeof ApplyPublicIdRoute
  '/clients': typeof AuthMainClientsRoute
  '/colleagues': typeof AuthMainColleaguesRoute
  '/company': typeof AuthMainCompanyRoute
  '/dashboard': typeof AuthMainDashboardRoute
  '/integrations': typeof AuthMainIntegrationsRoute
  '/invitations': typeof AuthMainInvitationsRoute
  '/profile': typeof AuthMainProfileRoute
  '/settings': typeof AuthMainSettingsRoute
  '/campaigns/$campaignId': typeof AuthMainCampaignsCampaignIdRouteWithChildren
  '/users/create': typeof AuthMainUsersCreateRoute
  '/webhooks/$webhookId': typeof AuthMainWebhooksWebhookIdRoute
  '/websites/$siteId': typeof AuthMainWebsitesSiteIdRouteWithChildren
  '/campaigns/create': typeof AuthSimpleCampaignsCreateRoute
  '/connect/wordpress': typeof AuthSimpleConnectWordpressRoute
  '/campaigns/$campaignId/full-board': typeof AuthCampaignsCampaignIdFullBoardRoute
  '/campaigns/': typeof AuthMainCampaignsIndexRoute
  '/candidates/': typeof AuthMainCandidatesIndexRoute
  '/companies/': typeof AuthMainCompaniesIndexRoute
  '/users/': typeof AuthMainUsersIndexRoute
  '/websites/': typeof AuthMainWebsitesIndexRoute
  '/whatsapp-business-accounts/': typeof AuthMainWhatsappBusinessAccountsIndexRoute
  '/campaigns/$campaignId/board': typeof AuthMainCampaignsCampaignIdBoardRoute
  '/campaigns/$campaignId/settings': typeof AuthMainCampaignsCampaignIdSettingsRouteWithChildren
  '/users/$userId/edit': typeof AuthMainUsersUserIdEditRoute
  '/websites/$siteId/settings': typeof AuthMainWebsitesSiteIdSettingsRouteWithChildren
  '/companies/$companyId/': typeof AuthMainCompaniesCompanyIdIndexRoute
  '/users/$userId/': typeof AuthMainUsersUserIdIndexRoute
  '/websites/$siteId/': typeof AuthMainWebsitesSiteIdIndexRoute
  '/whatsapp-business-accounts/$accountId/': typeof AuthMainWhatsappBusinessAccountsAccountIdIndexRoute
  '/campaigns/$campaignId/settings/candidate-sources': typeof AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute
  '/campaigns/$campaignId/settings/clients': typeof AuthMainCampaignsCampaignIdSettingsClientsRoute
  '/campaigns/$campaignId/settings/content': typeof AuthMainCampaignsCampaignIdSettingsContentRoute
  '/campaigns/$campaignId/settings/custom-attributes': typeof AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute
  '/campaigns/$campaignId/settings/lead-form': typeof AuthMainCampaignsCampaignIdSettingsLeadFormRoute
  '/campaigns/$campaignId/settings/missed-candidates': typeof AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute
  '/campaigns/$campaignId/settings/notifications': typeof AuthMainCampaignsCampaignIdSettingsNotificationsRoute
  '/campaigns/$campaignId/settings/try-out': typeof AuthMainCampaignsCampaignIdSettingsTryOutRoute
  '/campaigns/$campaignId/settings/whatsapp': typeof AuthMainCampaignsCampaignIdSettingsWhatsappRoute
  '/websites/$siteId/settings/apply-form': typeof AuthMainWebsitesSiteIdSettingsApplyFormRoute
  '/websites/$siteId/settings/chat': typeof AuthMainWebsitesSiteIdSettingsChatRoute
  '/websites/$siteId/settings/connection': typeof AuthMainWebsitesSiteIdSettingsConnectionRoute
  '/websites/$siteId/settings/knowledge': typeof AuthMainWebsitesSiteIdSettingsKnowledgeRoute
  '/websites/$siteId/settings/vacancies': typeof AuthMainWebsitesSiteIdSettingsVacanciesRoute
  '/websites/$siteId/settings/whatsapp': typeof AuthMainWebsitesSiteIdSettingsWhatsappRoute
  '/campaigns/$campaignId/settings/': typeof AuthMainCampaignsCampaignIdSettingsIndexRoute
  '/websites/$siteId/settings/': typeof AuthMainWebsitesSiteIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof GuestIndexRoute
  '/not-verified': typeof NotVerifiedRoute
  '/verified': typeof VerifiedRoute
  '/board': typeof AuthBoardRoute
  '/forgot': typeof GuestForgotRoute
  '/login': typeof GuestLoginRoute
  '/reset': typeof GuestResetRoute
  '/apply-preview/$siteKey': typeof ApplyPreviewSiteKeyRoute
  '/apply/$publicId': typeof ApplyPublicIdRoute
  '/clients': typeof AuthMainClientsRoute
  '/colleagues': typeof AuthMainColleaguesRoute
  '/company': typeof AuthMainCompanyRoute
  '/dashboard': typeof AuthMainDashboardRoute
  '/integrations': typeof AuthMainIntegrationsRoute
  '/invitations': typeof AuthMainInvitationsRoute
  '/profile': typeof AuthMainProfileRoute
  '/settings': typeof AuthMainSettingsRoute
  '/campaigns/$campaignId': typeof AuthMainCampaignsCampaignIdRouteWithChildren
  '/users/create': typeof AuthMainUsersCreateRoute
  '/webhooks/$webhookId': typeof AuthMainWebhooksWebhookIdRoute
  '/campaigns/create': typeof AuthSimpleCampaignsCreateRoute
  '/connect/wordpress': typeof AuthSimpleConnectWordpressRoute
  '/campaigns/$campaignId/full-board': typeof AuthCampaignsCampaignIdFullBoardRoute
  '/campaigns': typeof AuthMainCampaignsIndexRoute
  '/candidates': typeof AuthMainCandidatesIndexRoute
  '/companies': typeof AuthMainCompaniesIndexRoute
  '/users': typeof AuthMainUsersIndexRoute
  '/websites': typeof AuthMainWebsitesIndexRoute
  '/whatsapp-business-accounts': typeof AuthMainWhatsappBusinessAccountsIndexRoute
  '/campaigns/$campaignId/board': typeof AuthMainCampaignsCampaignIdBoardRoute
  '/users/$userId/edit': typeof AuthMainUsersUserIdEditRoute
  '/companies/$companyId': typeof AuthMainCompaniesCompanyIdIndexRoute
  '/users/$userId': typeof AuthMainUsersUserIdIndexRoute
  '/websites/$siteId': typeof AuthMainWebsitesSiteIdIndexRoute
  '/whatsapp-business-accounts/$accountId': typeof AuthMainWhatsappBusinessAccountsAccountIdIndexRoute
  '/campaigns/$campaignId/settings/candidate-sources': typeof AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute
  '/campaigns/$campaignId/settings/clients': typeof AuthMainCampaignsCampaignIdSettingsClientsRoute
  '/campaigns/$campaignId/settings/content': typeof AuthMainCampaignsCampaignIdSettingsContentRoute
  '/campaigns/$campaignId/settings/custom-attributes': typeof AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute
  '/campaigns/$campaignId/settings/lead-form': typeof AuthMainCampaignsCampaignIdSettingsLeadFormRoute
  '/campaigns/$campaignId/settings/missed-candidates': typeof AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute
  '/campaigns/$campaignId/settings/notifications': typeof AuthMainCampaignsCampaignIdSettingsNotificationsRoute
  '/campaigns/$campaignId/settings/try-out': typeof AuthMainCampaignsCampaignIdSettingsTryOutRoute
  '/campaigns/$campaignId/settings/whatsapp': typeof AuthMainCampaignsCampaignIdSettingsWhatsappRoute
  '/websites/$siteId/settings/apply-form': typeof AuthMainWebsitesSiteIdSettingsApplyFormRoute
  '/websites/$siteId/settings/chat': typeof AuthMainWebsitesSiteIdSettingsChatRoute
  '/websites/$siteId/settings/connection': typeof AuthMainWebsitesSiteIdSettingsConnectionRoute
  '/websites/$siteId/settings/knowledge': typeof AuthMainWebsitesSiteIdSettingsKnowledgeRoute
  '/websites/$siteId/settings/vacancies': typeof AuthMainWebsitesSiteIdSettingsVacanciesRoute
  '/websites/$siteId/settings/whatsapp': typeof AuthMainWebsitesSiteIdSettingsWhatsappRoute
  '/campaigns/$campaignId/settings': typeof AuthMainCampaignsCampaignIdSettingsIndexRoute
  '/websites/$siteId/settings': typeof AuthMainWebsitesSiteIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/not-verified': typeof NotVerifiedRoute
  '/verified': typeof VerifiedRoute
  '/_auth/_main': typeof AuthMainRouteWithChildren
  '/_auth/_simple': typeof AuthSimpleRouteWithChildren
  '/_auth/board': typeof AuthBoardRoute
  '/_guest/forgot': typeof GuestForgotRoute
  '/_guest/login': typeof GuestLoginRoute
  '/_guest/reset': typeof GuestResetRoute
  '/apply-preview/$siteKey': typeof ApplyPreviewSiteKeyRoute
  '/apply/$publicId': typeof ApplyPublicIdRoute
  '/_guest/': typeof GuestIndexRoute
  '/_auth/_main/clients': typeof AuthMainClientsRoute
  '/_auth/_main/colleagues': typeof AuthMainColleaguesRoute
  '/_auth/_main/company': typeof AuthMainCompanyRoute
  '/_auth/_main/dashboard': typeof AuthMainDashboardRoute
  '/_auth/_main/integrations': typeof AuthMainIntegrationsRoute
  '/_auth/_main/invitations': typeof AuthMainInvitationsRoute
  '/_auth/_main/profile': typeof AuthMainProfileRoute
  '/_auth/_main/settings': typeof AuthMainSettingsRoute
  '/_auth/_main/campaigns/$campaignId': typeof AuthMainCampaignsCampaignIdRouteWithChildren
  '/_auth/_main/users/create': typeof AuthMainUsersCreateRoute
  '/_auth/_main/webhooks/$webhookId': typeof AuthMainWebhooksWebhookIdRoute
  '/_auth/_main/websites/$siteId': typeof AuthMainWebsitesSiteIdRouteWithChildren
  '/_auth/_simple/campaigns/create': typeof AuthSimpleCampaignsCreateRoute
  '/_auth/_simple/connect/wordpress': typeof AuthSimpleConnectWordpressRoute
  '/_auth/campaigns/$campaignId/full-board': typeof AuthCampaignsCampaignIdFullBoardRoute
  '/_auth/_main/campaigns/': typeof AuthMainCampaignsIndexRoute
  '/_auth/_main/candidates/': typeof AuthMainCandidatesIndexRoute
  '/_auth/_main/companies/': typeof AuthMainCompaniesIndexRoute
  '/_auth/_main/users/': typeof AuthMainUsersIndexRoute
  '/_auth/_main/websites/': typeof AuthMainWebsitesIndexRoute
  '/_auth/_main/whatsapp-business-accounts/': typeof AuthMainWhatsappBusinessAccountsIndexRoute
  '/_auth/_main/campaigns/$campaignId/board': typeof AuthMainCampaignsCampaignIdBoardRoute
  '/_auth/_main/campaigns/$campaignId/settings': typeof AuthMainCampaignsCampaignIdSettingsRouteWithChildren
  '/_auth/_main/users/$userId/edit': typeof AuthMainUsersUserIdEditRoute
  '/_auth/_main/websites/$siteId/settings': typeof AuthMainWebsitesSiteIdSettingsRouteWithChildren
  '/_auth/_main/companies/$companyId/': typeof AuthMainCompaniesCompanyIdIndexRoute
  '/_auth/_main/users/$userId/': typeof AuthMainUsersUserIdIndexRoute
  '/_auth/_main/websites/$siteId/': typeof AuthMainWebsitesSiteIdIndexRoute
  '/_auth/_main/whatsapp-business-accounts/$accountId/': typeof AuthMainWhatsappBusinessAccountsAccountIdIndexRoute
  '/_auth/_main/campaigns/$campaignId/settings/candidate-sources': typeof AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute
  '/_auth/_main/campaigns/$campaignId/settings/clients': typeof AuthMainCampaignsCampaignIdSettingsClientsRoute
  '/_auth/_main/campaigns/$campaignId/settings/content': typeof AuthMainCampaignsCampaignIdSettingsContentRoute
  '/_auth/_main/campaigns/$campaignId/settings/custom-attributes': typeof AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute
  '/_auth/_main/campaigns/$campaignId/settings/lead-form': typeof AuthMainCampaignsCampaignIdSettingsLeadFormRoute
  '/_auth/_main/campaigns/$campaignId/settings/missed-candidates': typeof AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute
  '/_auth/_main/campaigns/$campaignId/settings/notifications': typeof AuthMainCampaignsCampaignIdSettingsNotificationsRoute
  '/_auth/_main/campaigns/$campaignId/settings/try-out': typeof AuthMainCampaignsCampaignIdSettingsTryOutRoute
  '/_auth/_main/campaigns/$campaignId/settings/whatsapp': typeof AuthMainCampaignsCampaignIdSettingsWhatsappRoute
  '/_auth/_main/websites/$siteId/settings/apply-form': typeof AuthMainWebsitesSiteIdSettingsApplyFormRoute
  '/_auth/_main/websites/$siteId/settings/chat': typeof AuthMainWebsitesSiteIdSettingsChatRoute
  '/_auth/_main/websites/$siteId/settings/connection': typeof AuthMainWebsitesSiteIdSettingsConnectionRoute
  '/_auth/_main/websites/$siteId/settings/knowledge': typeof AuthMainWebsitesSiteIdSettingsKnowledgeRoute
  '/_auth/_main/websites/$siteId/settings/vacancies': typeof AuthMainWebsitesSiteIdSettingsVacanciesRoute
  '/_auth/_main/websites/$siteId/settings/whatsapp': typeof AuthMainWebsitesSiteIdSettingsWhatsappRoute
  '/_auth/_main/campaigns/$campaignId/settings/': typeof AuthMainCampaignsCampaignIdSettingsIndexRoute
  '/_auth/_main/websites/$siteId/settings/': typeof AuthMainWebsitesSiteIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/not-verified'
    | '/verified'
    | '/board'
    | '/forgot'
    | '/login'
    | '/reset'
    | '/apply-preview/$siteKey'
    | '/apply/$publicId'
    | '/clients'
    | '/colleagues'
    | '/company'
    | '/dashboard'
    | '/integrations'
    | '/invitations'
    | '/profile'
    | '/settings'
    | '/campaigns/$campaignId'
    | '/users/create'
    | '/webhooks/$webhookId'
    | '/websites/$siteId'
    | '/campaigns/create'
    | '/connect/wordpress'
    | '/campaigns/$campaignId/full-board'
    | '/campaigns/'
    | '/candidates/'
    | '/companies/'
    | '/users/'
    | '/websites/'
    | '/whatsapp-business-accounts/'
    | '/campaigns/$campaignId/board'
    | '/campaigns/$campaignId/settings'
    | '/users/$userId/edit'
    | '/websites/$siteId/settings'
    | '/companies/$companyId/'
    | '/users/$userId/'
    | '/websites/$siteId/'
    | '/whatsapp-business-accounts/$accountId/'
    | '/campaigns/$campaignId/settings/candidate-sources'
    | '/campaigns/$campaignId/settings/clients'
    | '/campaigns/$campaignId/settings/content'
    | '/campaigns/$campaignId/settings/custom-attributes'
    | '/campaigns/$campaignId/settings/lead-form'
    | '/campaigns/$campaignId/settings/missed-candidates'
    | '/campaigns/$campaignId/settings/notifications'
    | '/campaigns/$campaignId/settings/try-out'
    | '/campaigns/$campaignId/settings/whatsapp'
    | '/websites/$siteId/settings/apply-form'
    | '/websites/$siteId/settings/chat'
    | '/websites/$siteId/settings/connection'
    | '/websites/$siteId/settings/knowledge'
    | '/websites/$siteId/settings/vacancies'
    | '/websites/$siteId/settings/whatsapp'
    | '/campaigns/$campaignId/settings/'
    | '/websites/$siteId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/not-verified'
    | '/verified'
    | '/board'
    | '/forgot'
    | '/login'
    | '/reset'
    | '/apply-preview/$siteKey'
    | '/apply/$publicId'
    | '/clients'
    | '/colleagues'
    | '/company'
    | '/dashboard'
    | '/integrations'
    | '/invitations'
    | '/profile'
    | '/settings'
    | '/campaigns/$campaignId'
    | '/users/create'
    | '/webhooks/$webhookId'
    | '/campaigns/create'
    | '/connect/wordpress'
    | '/campaigns/$campaignId/full-board'
    | '/campaigns'
    | '/candidates'
    | '/companies'
    | '/users'
    | '/websites'
    | '/whatsapp-business-accounts'
    | '/campaigns/$campaignId/board'
    | '/users/$userId/edit'
    | '/companies/$companyId'
    | '/users/$userId'
    | '/websites/$siteId'
    | '/whatsapp-business-accounts/$accountId'
    | '/campaigns/$campaignId/settings/candidate-sources'
    | '/campaigns/$campaignId/settings/clients'
    | '/campaigns/$campaignId/settings/content'
    | '/campaigns/$campaignId/settings/custom-attributes'
    | '/campaigns/$campaignId/settings/lead-form'
    | '/campaigns/$campaignId/settings/missed-candidates'
    | '/campaigns/$campaignId/settings/notifications'
    | '/campaigns/$campaignId/settings/try-out'
    | '/campaigns/$campaignId/settings/whatsapp'
    | '/websites/$siteId/settings/apply-form'
    | '/websites/$siteId/settings/chat'
    | '/websites/$siteId/settings/connection'
    | '/websites/$siteId/settings/knowledge'
    | '/websites/$siteId/settings/vacancies'
    | '/websites/$siteId/settings/whatsapp'
    | '/campaigns/$campaignId/settings'
    | '/websites/$siteId/settings'
  id:
    | '__root__'
    | '/_auth'
    | '/_guest'
    | '/not-verified'
    | '/verified'
    | '/_auth/_main'
    | '/_auth/_simple'
    | '/_auth/board'
    | '/_guest/forgot'
    | '/_guest/login'
    | '/_guest/reset'
    | '/apply-preview/$siteKey'
    | '/apply/$publicId'
    | '/_guest/'
    | '/_auth/_main/clients'
    | '/_auth/_main/colleagues'
    | '/_auth/_main/company'
    | '/_auth/_main/dashboard'
    | '/_auth/_main/integrations'
    | '/_auth/_main/invitations'
    | '/_auth/_main/profile'
    | '/_auth/_main/settings'
    | '/_auth/_main/campaigns/$campaignId'
    | '/_auth/_main/users/create'
    | '/_auth/_main/webhooks/$webhookId'
    | '/_auth/_main/websites/$siteId'
    | '/_auth/_simple/campaigns/create'
    | '/_auth/_simple/connect/wordpress'
    | '/_auth/campaigns/$campaignId/full-board'
    | '/_auth/_main/campaigns/'
    | '/_auth/_main/candidates/'
    | '/_auth/_main/companies/'
    | '/_auth/_main/users/'
    | '/_auth/_main/websites/'
    | '/_auth/_main/whatsapp-business-accounts/'
    | '/_auth/_main/campaigns/$campaignId/board'
    | '/_auth/_main/campaigns/$campaignId/settings'
    | '/_auth/_main/users/$userId/edit'
    | '/_auth/_main/websites/$siteId/settings'
    | '/_auth/_main/companies/$companyId/'
    | '/_auth/_main/users/$userId/'
    | '/_auth/_main/websites/$siteId/'
    | '/_auth/_main/whatsapp-business-accounts/$accountId/'
    | '/_auth/_main/campaigns/$campaignId/settings/candidate-sources'
    | '/_auth/_main/campaigns/$campaignId/settings/clients'
    | '/_auth/_main/campaigns/$campaignId/settings/content'
    | '/_auth/_main/campaigns/$campaignId/settings/custom-attributes'
    | '/_auth/_main/campaigns/$campaignId/settings/lead-form'
    | '/_auth/_main/campaigns/$campaignId/settings/missed-candidates'
    | '/_auth/_main/campaigns/$campaignId/settings/notifications'
    | '/_auth/_main/campaigns/$campaignId/settings/try-out'
    | '/_auth/_main/campaigns/$campaignId/settings/whatsapp'
    | '/_auth/_main/websites/$siteId/settings/apply-form'
    | '/_auth/_main/websites/$siteId/settings/chat'
    | '/_auth/_main/websites/$siteId/settings/connection'
    | '/_auth/_main/websites/$siteId/settings/knowledge'
    | '/_auth/_main/websites/$siteId/settings/vacancies'
    | '/_auth/_main/websites/$siteId/settings/whatsapp'
    | '/_auth/_main/campaigns/$campaignId/settings/'
    | '/_auth/_main/websites/$siteId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  NotVerifiedRoute: typeof NotVerifiedRoute
  VerifiedRoute: typeof VerifiedRoute
  ApplyPreviewSiteKeyRoute: typeof ApplyPreviewSiteKeyRoute
  ApplyPublicIdRoute: typeof ApplyPublicIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-verified': {
      id: '/not-verified'
      path: '/not-verified'
      fullPath: '/not-verified'
      preLoaderRoute: typeof NotVerifiedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verified': {
      id: '/verified'
      path: '/verified'
      fullPath: '/verified'
      preLoaderRoute: typeof VerifiedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_main': {
      id: '/_auth/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthMainRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_simple': {
      id: '/_auth/_simple'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthSimpleRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/board': {
      id: '/_auth/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof AuthBoardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_guest/': {
      id: '/_guest/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof GuestIndexRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/forgot': {
      id: '/_guest/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof GuestForgotRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/login': {
      id: '/_guest/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/reset': {
      id: '/_guest/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof GuestResetRouteImport
      parentRoute: typeof GuestRoute
    }
    '/apply-preview/$siteKey': {
      id: '/apply-preview/$siteKey'
      path: '/apply-preview/$siteKey'
      fullPath: '/apply-preview/$siteKey'
      preLoaderRoute: typeof ApplyPreviewSiteKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/$publicId': {
      id: '/apply/$publicId'
      path: '/apply/$publicId'
      fullPath: '/apply/$publicId'
      preLoaderRoute: typeof ApplyPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_main/clients': {
      id: '/_auth/_main/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthMainClientsRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/colleagues': {
      id: '/_auth/_main/colleagues'
      path: '/colleagues'
      fullPath: '/colleagues'
      preLoaderRoute: typeof AuthMainColleaguesRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/company': {
      id: '/_auth/_main/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AuthMainCompanyRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/dashboard': {
      id: '/_auth/_main/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthMainDashboardRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/integrations': {
      id: '/_auth/_main/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthMainIntegrationsRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/invitations': {
      id: '/_auth/_main/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof AuthMainInvitationsRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/profile': {
      id: '/_auth/_main/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthMainProfileRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/settings': {
      id: '/_auth/_main/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthMainSettingsRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/campaigns/': {
      id: '/_auth/_main/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthMainCampaignsIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/campaigns/$campaignId': {
      id: '/_auth/_main/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/candidates/': {
      id: '/_auth/_main/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof AuthMainCandidatesIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/companies/': {
      id: '/_auth/_main/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthMainCompaniesIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/users/': {
      id: '/_auth/_main/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthMainUsersIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/users/create': {
      id: '/_auth/_main/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof AuthMainUsersCreateRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/webhooks/$webhookId': {
      id: '/_auth/_main/webhooks/$webhookId'
      path: '/webhooks/$webhookId'
      fullPath: '/webhooks/$webhookId'
      preLoaderRoute: typeof AuthMainWebhooksWebhookIdRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/websites/': {
      id: '/_auth/_main/websites/'
      path: '/websites'
      fullPath: '/websites/'
      preLoaderRoute: typeof AuthMainWebsitesIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/websites/$siteId': {
      id: '/_auth/_main/websites/$siteId'
      path: '/websites/$siteId'
      fullPath: '/websites/$siteId'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/whatsapp-business-accounts/': {
      id: '/_auth/_main/whatsapp-business-accounts/'
      path: '/whatsapp-business-accounts'
      fullPath: '/whatsapp-business-accounts/'
      preLoaderRoute: typeof AuthMainWhatsappBusinessAccountsIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_simple/campaigns/create': {
      id: '/_auth/_simple/campaigns/create'
      path: '/campaigns/create'
      fullPath: '/campaigns/create'
      preLoaderRoute: typeof AuthSimpleCampaignsCreateRouteImport
      parentRoute: typeof AuthSimpleRoute
    }
    '/_auth/_simple/connect/wordpress': {
      id: '/_auth/_simple/connect/wordpress'
      path: '/connect/wordpress'
      fullPath: '/connect/wordpress'
      preLoaderRoute: typeof AuthSimpleConnectWordpressRouteImport
      parentRoute: typeof AuthSimpleRoute
    }
    '/_auth/campaigns/$campaignId/full-board': {
      id: '/_auth/campaigns/$campaignId/full-board'
      path: '/campaigns/$campaignId/full-board'
      fullPath: '/campaigns/$campaignId/full-board'
      preLoaderRoute: typeof AuthCampaignsCampaignIdFullBoardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_main/campaigns/$campaignId/board': {
      id: '/_auth/_main/campaigns/$campaignId/board'
      path: '/board'
      fullPath: '/campaigns/$campaignId/board'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdBoardRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings': {
      id: '/_auth/_main/campaigns/$campaignId/settings'
      path: '/settings'
      fullPath: '/campaigns/$campaignId/settings'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdRoute
    }
    '/_auth/_main/companies/$companyId/': {
      id: '/_auth/_main/companies/$companyId/'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof AuthMainCompaniesCompanyIdIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/users/$userId/': {
      id: '/_auth/_main/users/$userId/'
      path: '/users/$userId'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof AuthMainUsersUserIdIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/users/$userId/edit': {
      id: '/_auth/_main/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AuthMainUsersUserIdEditRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/websites/$siteId/': {
      id: '/_auth/_main/websites/$siteId/'
      path: '/'
      fullPath: '/websites/$siteId/'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdIndexRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdRoute
    }
    '/_auth/_main/websites/$siteId/settings': {
      id: '/_auth/_main/websites/$siteId/settings'
      path: '/settings'
      fullPath: '/websites/$siteId/settings'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdRoute
    }
    '/_auth/_main/whatsapp-business-accounts/$accountId/': {
      id: '/_auth/_main/whatsapp-business-accounts/$accountId/'
      path: '/whatsapp-business-accounts/$accountId'
      fullPath: '/whatsapp-business-accounts/$accountId/'
      preLoaderRoute: typeof AuthMainWhatsappBusinessAccountsAccountIdIndexRouteImport
      parentRoute: typeof AuthMainRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/': {
      id: '/_auth/_main/campaigns/$campaignId/settings/'
      path: '/'
      fullPath: '/campaigns/$campaignId/settings/'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsIndexRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/candidate-sources': {
      id: '/_auth/_main/campaigns/$campaignId/settings/candidate-sources'
      path: '/candidate-sources'
      fullPath: '/campaigns/$campaignId/settings/candidate-sources'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsCandidateSourcesRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/clients': {
      id: '/_auth/_main/campaigns/$campaignId/settings/clients'
      path: '/clients'
      fullPath: '/campaigns/$campaignId/settings/clients'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsClientsRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/content': {
      id: '/_auth/_main/campaigns/$campaignId/settings/content'
      path: '/content'
      fullPath: '/campaigns/$campaignId/settings/content'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsContentRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/custom-attributes': {
      id: '/_auth/_main/campaigns/$campaignId/settings/custom-attributes'
      path: '/custom-attributes'
      fullPath: '/campaigns/$campaignId/settings/custom-attributes'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsCustomAttributesRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/lead-form': {
      id: '/_auth/_main/campaigns/$campaignId/settings/lead-form'
      path: '/lead-form'
      fullPath: '/campaigns/$campaignId/settings/lead-form'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsLeadFormRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/missed-candidates': {
      id: '/_auth/_main/campaigns/$campaignId/settings/missed-candidates'
      path: '/missed-candidates'
      fullPath: '/campaigns/$campaignId/settings/missed-candidates'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsMissedCandidatesRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/notifications': {
      id: '/_auth/_main/campaigns/$campaignId/settings/notifications'
      path: '/notifications'
      fullPath: '/campaigns/$campaignId/settings/notifications'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsNotificationsRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/try-out': {
      id: '/_auth/_main/campaigns/$campaignId/settings/try-out'
      path: '/try-out'
      fullPath: '/campaigns/$campaignId/settings/try-out'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsTryOutRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/campaigns/$campaignId/settings/whatsapp': {
      id: '/_auth/_main/campaigns/$campaignId/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/campaigns/$campaignId/settings/whatsapp'
      preLoaderRoute: typeof AuthMainCampaignsCampaignIdSettingsWhatsappRouteImport
      parentRoute: typeof AuthMainCampaignsCampaignIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/': {
      id: '/_auth/_main/websites/$siteId/settings/'
      path: '/'
      fullPath: '/websites/$siteId/settings/'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsIndexRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/apply-form': {
      id: '/_auth/_main/websites/$siteId/settings/apply-form'
      path: '/apply-form'
      fullPath: '/websites/$siteId/settings/apply-form'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsApplyFormRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/chat': {
      id: '/_auth/_main/websites/$siteId/settings/chat'
      path: '/chat'
      fullPath: '/websites/$siteId/settings/chat'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsChatRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/connection': {
      id: '/_auth/_main/websites/$siteId/settings/connection'
      path: '/connection'
      fullPath: '/websites/$siteId/settings/connection'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsConnectionRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/knowledge': {
      id: '/_auth/_main/websites/$siteId/settings/knowledge'
      path: '/knowledge'
      fullPath: '/websites/$siteId/settings/knowledge'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsKnowledgeRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/vacancies': {
      id: '/_auth/_main/websites/$siteId/settings/vacancies'
      path: '/vacancies'
      fullPath: '/websites/$siteId/settings/vacancies'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsVacanciesRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
    '/_auth/_main/websites/$siteId/settings/whatsapp': {
      id: '/_auth/_main/websites/$siteId/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/websites/$siteId/settings/whatsapp'
      preLoaderRoute: typeof AuthMainWebsitesSiteIdSettingsWhatsappRouteImport
      parentRoute: typeof AuthMainWebsitesSiteIdSettingsRoute
    }
  }
}

interface AuthMainCampaignsCampaignIdSettingsRouteChildren {
  AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute: typeof AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute
  AuthMainCampaignsCampaignIdSettingsClientsRoute: typeof AuthMainCampaignsCampaignIdSettingsClientsRoute
  AuthMainCampaignsCampaignIdSettingsContentRoute: typeof AuthMainCampaignsCampaignIdSettingsContentRoute
  AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute: typeof AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute
  AuthMainCampaignsCampaignIdSettingsLeadFormRoute: typeof AuthMainCampaignsCampaignIdSettingsLeadFormRoute
  AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute: typeof AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute
  AuthMainCampaignsCampaignIdSettingsNotificationsRoute: typeof AuthMainCampaignsCampaignIdSettingsNotificationsRoute
  AuthMainCampaignsCampaignIdSettingsTryOutRoute: typeof AuthMainCampaignsCampaignIdSettingsTryOutRoute
  AuthMainCampaignsCampaignIdSettingsWhatsappRoute: typeof AuthMainCampaignsCampaignIdSettingsWhatsappRoute
  AuthMainCampaignsCampaignIdSettingsIndexRoute: typeof AuthMainCampaignsCampaignIdSettingsIndexRoute
}

const AuthMainCampaignsCampaignIdSettingsRouteChildren: AuthMainCampaignsCampaignIdSettingsRouteChildren =
  {
    AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute:
      AuthMainCampaignsCampaignIdSettingsCandidateSourcesRoute,
    AuthMainCampaignsCampaignIdSettingsClientsRoute:
      AuthMainCampaignsCampaignIdSettingsClientsRoute,
    AuthMainCampaignsCampaignIdSettingsContentRoute:
      AuthMainCampaignsCampaignIdSettingsContentRoute,
    AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute:
      AuthMainCampaignsCampaignIdSettingsCustomAttributesRoute,
    AuthMainCampaignsCampaignIdSettingsLeadFormRoute:
      AuthMainCampaignsCampaignIdSettingsLeadFormRoute,
    AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute:
      AuthMainCampaignsCampaignIdSettingsMissedCandidatesRoute,
    AuthMainCampaignsCampaignIdSettingsNotificationsRoute:
      AuthMainCampaignsCampaignIdSettingsNotificationsRoute,
    AuthMainCampaignsCampaignIdSettingsTryOutRoute:
      AuthMainCampaignsCampaignIdSettingsTryOutRoute,
    AuthMainCampaignsCampaignIdSettingsWhatsappRoute:
      AuthMainCampaignsCampaignIdSettingsWhatsappRoute,
    AuthMainCampaignsCampaignIdSettingsIndexRoute:
      AuthMainCampaignsCampaignIdSettingsIndexRoute,
  }

const AuthMainCampaignsCampaignIdSettingsRouteWithChildren =
  AuthMainCampaignsCampaignIdSettingsRoute._addFileChildren(
    AuthMainCampaignsCampaignIdSettingsRouteChildren,
  )

interface AuthMainCampaignsCampaignIdRouteChildren {
  AuthMainCampaignsCampaignIdBoardRoute: typeof AuthMainCampaignsCampaignIdBoardRoute
  AuthMainCampaignsCampaignIdSettingsRoute: typeof AuthMainCampaignsCampaignIdSettingsRouteWithChildren
}

const AuthMainCampaignsCampaignIdRouteChildren: AuthMainCampaignsCampaignIdRouteChildren =
  {
    AuthMainCampaignsCampaignIdBoardRoute:
      AuthMainCampaignsCampaignIdBoardRoute,
    AuthMainCampaignsCampaignIdSettingsRoute:
      AuthMainCampaignsCampaignIdSettingsRouteWithChildren,
  }

const AuthMainCampaignsCampaignIdRouteWithChildren =
  AuthMainCampaignsCampaignIdRoute._addFileChildren(
    AuthMainCampaignsCampaignIdRouteChildren,
  )

interface AuthMainWebsitesSiteIdSettingsRouteChildren {
  AuthMainWebsitesSiteIdSettingsApplyFormRoute: typeof AuthMainWebsitesSiteIdSettingsApplyFormRoute
  AuthMainWebsitesSiteIdSettingsChatRoute: typeof AuthMainWebsitesSiteIdSettingsChatRoute
  AuthMainWebsitesSiteIdSettingsConnectionRoute: typeof AuthMainWebsitesSiteIdSettingsConnectionRoute
  AuthMainWebsitesSiteIdSettingsKnowledgeRoute: typeof AuthMainWebsitesSiteIdSettingsKnowledgeRoute
  AuthMainWebsitesSiteIdSettingsVacanciesRoute: typeof AuthMainWebsitesSiteIdSettingsVacanciesRoute
  AuthMainWebsitesSiteIdSettingsWhatsappRoute: typeof AuthMainWebsitesSiteIdSettingsWhatsappRoute
  AuthMainWebsitesSiteIdSettingsIndexRoute: typeof AuthMainWebsitesSiteIdSettingsIndexRoute
}

const AuthMainWebsitesSiteIdSettingsRouteChildren: AuthMainWebsitesSiteIdSettingsRouteChildren =
  {
    AuthMainWebsitesSiteIdSettingsApplyFormRoute:
      AuthMainWebsitesSiteIdSettingsApplyFormRoute,
    AuthMainWebsitesSiteIdSettingsChatRoute:
      AuthMainWebsitesSiteIdSettingsChatRoute,
    AuthMainWebsitesSiteIdSettingsConnectionRoute:
      AuthMainWebsitesSiteIdSettingsConnectionRoute,
    AuthMainWebsitesSiteIdSettingsKnowledgeRoute:
      AuthMainWebsitesSiteIdSettingsKnowledgeRoute,
    AuthMainWebsitesSiteIdSettingsVacanciesRoute:
      AuthMainWebsitesSiteIdSettingsVacanciesRoute,
    AuthMainWebsitesSiteIdSettingsWhatsappRoute:
      AuthMainWebsitesSiteIdSettingsWhatsappRoute,
    AuthMainWebsitesSiteIdSettingsIndexRoute:
      AuthMainWebsitesSiteIdSettingsIndexRoute,
  }

const AuthMainWebsitesSiteIdSettingsRouteWithChildren =
  AuthMainWebsitesSiteIdSettingsRoute._addFileChildren(
    AuthMainWebsitesSiteIdSettingsRouteChildren,
  )

interface AuthMainWebsitesSiteIdRouteChildren {
  AuthMainWebsitesSiteIdSettingsRoute: typeof AuthMainWebsitesSiteIdSettingsRouteWithChildren
  AuthMainWebsitesSiteIdIndexRoute: typeof AuthMainWebsitesSiteIdIndexRoute
}

const AuthMainWebsitesSiteIdRouteChildren: AuthMainWebsitesSiteIdRouteChildren =
  {
    AuthMainWebsitesSiteIdSettingsRoute:
      AuthMainWebsitesSiteIdSettingsRouteWithChildren,
    AuthMainWebsitesSiteIdIndexRoute: AuthMainWebsitesSiteIdIndexRoute,
  }

const AuthMainWebsitesSiteIdRouteWithChildren =
  AuthMainWebsitesSiteIdRoute._addFileChildren(
    AuthMainWebsitesSiteIdRouteChildren,
  )

interface AuthMainRouteChildren {
  AuthMainClientsRoute: typeof AuthMainClientsRoute
  AuthMainColleaguesRoute: typeof AuthMainColleaguesRoute
  AuthMainCompanyRoute: typeof AuthMainCompanyRoute
  AuthMainDashboardRoute: typeof AuthMainDashboardRoute
  AuthMainIntegrationsRoute: typeof AuthMainIntegrationsRoute
  AuthMainInvitationsRoute: typeof AuthMainInvitationsRoute
  AuthMainProfileRoute: typeof AuthMainProfileRoute
  AuthMainSettingsRoute: typeof AuthMainSettingsRoute
  AuthMainCampaignsCampaignIdRoute: typeof AuthMainCampaignsCampaignIdRouteWithChildren
  AuthMainUsersCreateRoute: typeof AuthMainUsersCreateRoute
  AuthMainWebhooksWebhookIdRoute: typeof AuthMainWebhooksWebhookIdRoute
  AuthMainWebsitesSiteIdRoute: typeof AuthMainWebsitesSiteIdRouteWithChildren
  AuthMainCampaignsIndexRoute: typeof AuthMainCampaignsIndexRoute
  AuthMainCandidatesIndexRoute: typeof AuthMainCandidatesIndexRoute
  AuthMainCompaniesIndexRoute: typeof AuthMainCompaniesIndexRoute
  AuthMainUsersIndexRoute: typeof AuthMainUsersIndexRoute
  AuthMainWebsitesIndexRoute: typeof AuthMainWebsitesIndexRoute
  AuthMainWhatsappBusinessAccountsIndexRoute: typeof AuthMainWhatsappBusinessAccountsIndexRoute
  AuthMainUsersUserIdEditRoute: typeof AuthMainUsersUserIdEditRoute
  AuthMainCompaniesCompanyIdIndexRoute: typeof AuthMainCompaniesCompanyIdIndexRoute
  AuthMainUsersUserIdIndexRoute: typeof AuthMainUsersUserIdIndexRoute
  AuthMainWhatsappBusinessAccountsAccountIdIndexRoute: typeof AuthMainWhatsappBusinessAccountsAccountIdIndexRoute
}

const AuthMainRouteChildren: AuthMainRouteChildren = {
  AuthMainClientsRoute: AuthMainClientsRoute,
  AuthMainColleaguesRoute: AuthMainColleaguesRoute,
  AuthMainCompanyRoute: AuthMainCompanyRoute,
  AuthMainDashboardRoute: AuthMainDashboardRoute,
  AuthMainIntegrationsRoute: AuthMainIntegrationsRoute,
  AuthMainInvitationsRoute: AuthMainInvitationsRoute,
  AuthMainProfileRoute: AuthMainProfileRoute,
  AuthMainSettingsRoute: AuthMainSettingsRoute,
  AuthMainCampaignsCampaignIdRoute:
    AuthMainCampaignsCampaignIdRouteWithChildren,
  AuthMainUsersCreateRoute: AuthMainUsersCreateRoute,
  AuthMainWebhooksWebhookIdRoute: AuthMainWebhooksWebhookIdRoute,
  AuthMainWebsitesSiteIdRoute: AuthMainWebsitesSiteIdRouteWithChildren,
  AuthMainCampaignsIndexRoute: AuthMainCampaignsIndexRoute,
  AuthMainCandidatesIndexRoute: AuthMainCandidatesIndexRoute,
  AuthMainCompaniesIndexRoute: AuthMainCompaniesIndexRoute,
  AuthMainUsersIndexRoute: AuthMainUsersIndexRoute,
  AuthMainWebsitesIndexRoute: AuthMainWebsitesIndexRoute,
  AuthMainWhatsappBusinessAccountsIndexRoute:
    AuthMainWhatsappBusinessAccountsIndexRoute,
  AuthMainUsersUserIdEditRoute: AuthMainUsersUserIdEditRoute,
  AuthMainCompaniesCompanyIdIndexRoute: AuthMainCompaniesCompanyIdIndexRoute,
  AuthMainUsersUserIdIndexRoute: AuthMainUsersUserIdIndexRoute,
  AuthMainWhatsappBusinessAccountsAccountIdIndexRoute:
    AuthMainWhatsappBusinessAccountsAccountIdIndexRoute,
}

const AuthMainRouteWithChildren = AuthMainRoute._addFileChildren(
  AuthMainRouteChildren,
)

interface AuthSimpleRouteChildren {
  AuthSimpleCampaignsCreateRoute: typeof AuthSimpleCampaignsCreateRoute
  AuthSimpleConnectWordpressRoute: typeof AuthSimpleConnectWordpressRoute
}

const AuthSimpleRouteChildren: AuthSimpleRouteChildren = {
  AuthSimpleCampaignsCreateRoute: AuthSimpleCampaignsCreateRoute,
  AuthSimpleConnectWordpressRoute: AuthSimpleConnectWordpressRoute,
}

const AuthSimpleRouteWithChildren = AuthSimpleRoute._addFileChildren(
  AuthSimpleRouteChildren,
)

interface AuthRouteChildren {
  AuthMainRoute: typeof AuthMainRouteWithChildren
  AuthSimpleRoute: typeof AuthSimpleRouteWithChildren
  AuthBoardRoute: typeof AuthBoardRoute
  AuthCampaignsCampaignIdFullBoardRoute: typeof AuthCampaignsCampaignIdFullBoardRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMainRoute: AuthMainRouteWithChildren,
  AuthSimpleRoute: AuthSimpleRouteWithChildren,
  AuthBoardRoute: AuthBoardRoute,
  AuthCampaignsCampaignIdFullBoardRoute: AuthCampaignsCampaignIdFullBoardRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface GuestRouteChildren {
  GuestForgotRoute: typeof GuestForgotRoute
  GuestLoginRoute: typeof GuestLoginRoute
  GuestResetRoute: typeof GuestResetRoute
  GuestIndexRoute: typeof GuestIndexRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestForgotRoute: GuestForgotRoute,
  GuestLoginRoute: GuestLoginRoute,
  GuestResetRoute: GuestResetRoute,
  GuestIndexRoute: GuestIndexRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  NotVerifiedRoute: NotVerifiedRoute,
  VerifiedRoute: VerifiedRoute,
  ApplyPreviewSiteKeyRoute: ApplyPreviewSiteKeyRoute,
  ApplyPublicIdRoute: ApplyPublicIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
